<template>
  <div
    class="flex-1 flex flex-col max-h-full"
    v-allow:auth="[
      'batchProcessing.read',
      'batchProcessing.create',
      'batchProcessing.edit',
    ]"
  >
    <sub-header
      :handleSearchFilter="handleSearchFilter"
      :showBtn="
        checkPermission('batchProcessing.create') ||
        checkPermission('batchProcessing.edit')
      "
      :buttonText="$t('pages.batch_processing_table.create_new')"
      :handleClick="showBatchModal"
      :showBreadCrumbs="false"
      :buttonLoader="createBatchLoading"
      :disabled="createBatchLoading"
    />

    <div
      class="flex flex-1 flex-col flex-grow max-h-full max-w-full overflow-auto scroll-bar"
    >
      <Table
        id="BatchProcessingTable"
        :columns="columnOption"
        :key="pageData.total"
        :rows="checks"
        @handleClone="handleCloneCheck($event)"
        :isLoading="isLoading"
        :filters="serverParams"
        :filterOptions="columnFilterOptions"
        :filterOptionsAsync="columnFilterOptionsAsync"
        @per-page-change="onPageChange($event, true)"
        @page-change="onPageChange($event)"
        @column-filter="onColumnFilters($event)"
        :paginationOptions="paginationOptions"
        :totalRows="pageData.total"
        @filters-clear="clearFilters"
        sortingEnabled
        @sort-change="onSortChange"
        @search-filter="getSearchOptionsTick($event)"
      >
        <!-- <template #link="customData">
          <div class="truncate max-w-full whitespace-nowrap cursor-pointer">
            <span v-tippy :content="customData.customData.name">
              {{ customData.customData.name }}
            </span>
          </div>
        </template>
        <template #source="customData">
          <span
            class="inline-flex rounded-sm px-2 text-xs font-semibold leading-5 truncate"
            :class="
              customData.customData.is_custom
                ? 'bg-green-100 text-green-800'
                : 'bg-blue-200 text-blue-800'
            "
            >{{ isRestrictedOrCustom(customData.customData) }}</span
          >
        </template>
        <template #show_info="customData">
          <p
            :class="
              customData.customData && customData.customData.in_packages > 0
                ? 'text-primary hover:text-primary-300 hover:underline cursor-pointer'
                : 'text-gray-500'
            "
            @click.stop="setCheckPackages(customData.customData)"
          >
            {{
              $t("pages.check_admin.used_in_packages", {
                value: customData.customData.in_packages,
              })
            }}
          </p>
        </template> -->
        <template #batch_status="customData">
          <div>
            <span
              v-if="
                customData.customData.batch_status === 'PROCESSING' &&
                customData.customData.case_created !== undefined &&
                customData.customData.total_cases !== undefined
              "
            >
              {{ customData.customData.case_created }}/{{
                customData.customData.total_cases
              }}
              {{ customData.customData.batch_status }}
            </span>
            <span v-else>{{ customData.customData.batch_status }}</span>
          </div>
        </template>
        <template #actions="customData">
          <div class="flex justify-around">
            <router-link
              :to="{
                name: 'Batch Processing Details',
                params: { id: customData.customData.id, action: 'view' },
              }"
              class="text-primary truncate max-w-full whitespace-nowrap cursor-pointer hover:text-primary"
            >
              <button
                class="h-8 w-4 disabled:opacity-50 mx-2"
                v-tippy
                :content="'View'"
                :disabled="!canPerformBatchAction(customData.customData, 'view')"
              >
                <font-awesome-icon
                  icon="eye"
                  class="text-blue-600 text-lg fa-3x"
                  :class="
                    customData.customData
                      ? 'text-primary hover:text-dvbrandhoveron hover:underline cursor-pointer'
                      : 'text-gray-500'
                  "
                />
              </button>
            </router-link>

            <router-link
              :to="
                customData.customData.lock &&
                customData.customData.locked_by !== $store.getters.getUser?.id
                  ? {}
                  : {
                      name: 'Batch Processing Details',
                      params: { id: customData.customData.id, action: 'edit' },
                    }
              "
              :class="[
                'text-primary truncate max-w-full whitespace-nowrap',
                !canPerformBatchAction(customData.customData, 'edit')
                  ? 'cursor-not-allowed' 
                  : 'cursor-pointer hover:text-primary'
              ]"
            >
              <button
                class="h-8 w-4 disabled:opacity-50 mx-2"
                :disabled="!canPerformBatchAction(customData.customData, 'edit')"
                  v-tippy
                :content="'Edit'"
              >
                <font-awesome-icon
                  icon="edit"
                  class="text-blue-600 text-lg fa-3x"
                  :class="[
                    customData.customData ? 'text-primary' : 'text-gray-500',
                    !canPerformBatchAction(customData.customData, 'edit')
                      ? 'cursor-not-allowed'
                      : 'hover:text-dvbrandhoveron hover:underline cursor-pointer',
                  ]"
                />
              </button>
            </router-link>

            <button
              :class="[
                'h-6 w-4 mx-2 mt-1 disabled:opacity-50',
                (!canPerformBatchAction(customData.customData, 'delete') || deleteLoading)
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer',
              ]"
              @click="handleDelete(customData.customData)"
              v-tippy
              :content="'Delete'"
              :disabled="!canPerformBatchAction(customData.customData, 'delete') || deleteLoading"
            >
              <font-awesome-icon
                icon="trash"
                class="text-blue-600 text-lg fa-2x"
                :class="[
                  customData.customData ? 'text-danger' : 'text-gray-500',
                  (!canPerformBatchAction(customData.customData, 'delete') || deleteLoading)
                    ? 'cursor-not-allowed'
                    : 'hover:text-dvbrandhoveron hover:underline cursor-pointer',
                ]"
              />
            </button>
          </div>
        </template>
      </Table>
    </div>

    <modal-content
      ref="batch-processing-modal"
      :max-width="480"
      name="batch-processing-modal"
      :title="$t('pages.batch_processing_table.add_new')"
      @close="closeModal"
      :showFooter="false"
      :contentScrollable="false"
    >
      <template #content>
        <FormulateForm #default="{ hasErrors }" class="min-h-full flex-1">
          <div class="add-check__modal-content h-full overflow-hidden">
            <div
              class="form flex w-full flex-col flex-1 overflow-auto scroll-bar pr-1 gap-2"
            >
              <FormulateInput
                v-show="!getIsClient"
                v-model="selectOrganization"
                validation="required"
                :label="$t('pages.batch_processing_table.organization')"
                :placeholder="
                  $t('pages.batch_processing_table.select_organization')
                "
                type="multi-select"
                :multiple="false"
                variant="alt"
                :options="organizationOptions"
                :config="{ label: 'name', trackBy: 'id' }"
                @input="handleSelectOrganization"
                :element-class="
                  (context, classes) => ['flex-1 min-w-full'].concat(classes)
                "
                :disabled="false"
                error-behavior="submit"
              />

              <FormulateInput
                v-show="
                  !!selectOrganization &&
                  packageOptions.length > 1 &&
                  !packageLoading
                "
                v-model="selectPackage"
                validation="required"
                :label="$t('pages.batch_processing_table.package')"
                :placeholder="$t('pages.batch_processing_table.select_package')"
                type="multi-select"
                :multiple="false"
                variant="alt"
                :options="packageOptions"
                :config="{ label: 'translated_label', trackBy: 'id' }"
                @input="handleSelectPackage"
                :element-class="
                  (context, classes) => ['flex-1 min-w-full'].concat(classes)
                "
                :disabled="false"
                error-behavior="submit"
              />

              <div
                v-show="packageLoading"
                class="flex justify-center items-center w-full py-4"
              >
                <Loader />
              </div>

              <FormulateInput
                v-show="!!selectPackage && entityTypeOptions.length > 1"
                v-model="selectedEntityTypes"
                validation="required"
                class="w-full"
                :label="$t('pages.field_table.entity_type')"
                :placeholder="$t('pages.field_table.select_entity_type')"
                type="multi-select"
                :multiple="false"
                variant="alt"
                :element-class="
                  (context, classes) => ['flex-1 min-w-full'].concat(classes)
                "
                :options="entityTypeOptions"
                :loading="false"
                :config="{
                  label: 'translated_label',
                  trackBy: 'id',
                  limit: 4,
                }"
                error-behavior="submit"
              />
            </div>
            <div class="card-actions justify-end">
              <Button
                :loader="createBatchLoading"
                :text="$t('actions.create')"
                type="primary"
                :disabled="hasErrors || createBatchLoading"
                @click="createNewBatch"
              />
            </div>
          </div>
        </FormulateForm>
      </template>
      <template #footer>
        <div></div>
      </template>
    </modal-content>
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import Table from "@shared/dashboard-components/table-large";
// import axios from "@/axios";
import BatchAxios from "./batch-axios";
import { debounce } from "lodash";
import modalContent from "@shared/modal-content";
import Button from "@/components/button";
import { checkPermission } from "@shared/utils/functions";
import { DateTime } from "luxon";
import { FormatDateNew } from "@/plugins/functions";
import { mapActions } from "vuex";
import { ENTITY_TYPES_DROPDOWN_CONFIG } from "@shared/utils/constants";
import { getFilterOptions } from "@shared/dashboard-components/table-large/utils";
import Loader from "@shared/loader";
import { mapGetters } from "vuex";
import { EventBus } from "@/main.js";


export default {
  name: "Batch-Processing",
  title: "Batch Processing",

  components: {
    SubHeader,
    Table,
    modalContent,
    Button,
    Loader,
  },
  props: {},
  data: () => ({
    getFilterOptions,
    ENTITY_TYPES_DROPDOWN_CONFIG,
    searchTimeout: null,
    searchLoading: {},
    columnFilterOptionsAsync: null,
    isEntityTypesLoading: false,
    serverParams: null,
    checks: [],
    isLoading: false,
    isCloning: false,
    searchValue: "",
    createBatchLoading: false,
    paginationOptions: {
      enabled: true,
      mode: "remote",
      perPage: 10,
    },
    pageData: {
      total: 0,
    },
    currentPageData: {
      page: 1,
      count: 10,
    },
    searchParams: {
      package: "",
    },
    sortParams: null,
    selectOrganization: null,
    organizationOptions: [],
    packageOptions: [],
    selectPackage: null,
    selectedEntityTypes: null,
    entityTypeOptions: [],
    packageLoading: false,
    deleteLoading: false,
    allBatchData: [],
    checkAllData: [],
  }),
  computed: {
    ...mapGetters(["getClientId", "getIsClient", "getTenantId"]),
    translatedRows() {
      return this.checks;
    },
    columns() {
      let col = [
        {
          label_key: "pages.batch_processing_table.batch_id",
          field: "batch_id",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.lock",
          field: "lock",
          config: { filter: true, type: "lock" },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },

        {
          label_key: "pages.batch_processing_table.locked_by",
          field: "locked_by_name",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.package",
          field: "package_name",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },

        {
          label_key: "pages.batch_processing_table.entity_type",
          field: "entity_type",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.created_by",
          field: "created_by",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.last_updated_at",
          field: "modified_at",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.last_updated_by",
          field: "modified_by",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.start_date",
          field: "start_date",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },
        {
          label_key: "pages.batch_processing_table.end_date",
          field: "end_date",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },

        {
          label_key: "pages.batch_processing_table.status",
          field: "batch_status",
          config: { filter: true, template: "batch_status" },
          tdClass: "truncate max-w-xs",
          sortable: true,
        },

        {
          label_key: "pages.field_table.actions",
          field: "actions",
          config: { filter: false, type: "actions" },
          sortable: false,
        },
      ];
      if (!this.getIsClient) {
        const organization = {
          label_key: "pages.batch_processing_table.organization",
          field: "organisation",
          config: { filter: true },
          tdClass: "truncate max-w-xs",
          sortable: true,
        };
        col.splice(3, 0, organization);
      }
      return col;
    },
    columnFilterOptions() {
      let cols = this.getFilterOptions(this.columns, this.checkAllData);
      // Fix lock field filter to show proper boolean values
      if (cols.lock) {
        cols.lock = [
          { id: "true", name: "true", value: true },
          { id: "false", name: "false", value: false },
        ];
      }
      // Filter out null values and format dates for start_date and end_date
      if (cols.start_date) {
        cols.start_date = cols.start_date.filter(
          (item) => item.name && item.name !== "null"
        );
      }
      if (cols.end_date) {
        cols.end_date = cols.end_date.filter(
          (item) => item.name && item.name !== "null"
        );
      }
      return cols;
    },
    columnOption() {
      return this.columns.map((el) => ({
        ...el,
        label: this.$t(el.label_key),
        config: {
          ...el.config,
          isLoading: !!this.searchLoading[el.field] || false,
        },
      }));
    },
  },

  async mounted() {
    try {
      await this.fetchBatchProcessingList();
      await this.fetchAllBatchProcessingList();
      this.getIsClient
        ? this.handleSelectOrganization({ id: this.getClientId })
        : await this.fetchAllOrganization();
    } catch (error) {
      console.error("Error in mounted:", error);
    }
    EventBus.$on("changeLanguageProfile", () => {  this.getIsClient ? this.fetchPackagesOptions() : ''})
  },
  beforeDestroy() {
    EventBus.$off("changeLanguageProfile");
  },

  methods: {
    ...mapActions(["fetchEntityTypeList"]),
    FormatDateNew,
    checkPermission,
    canPerformBatchAction(batchData, action = 'edit') {
      const hasEdit = checkPermission('batchProcessing.edit');
      const hasCreate = checkPermission('batchProcessing.create');
      const hasRead = checkPermission('batchProcessing.read');
      
      // Check batch status (DRAFT only for edit/delete)
      if ((action === 'edit' || action === 'delete') && batchData.batch_status !== 'DRAFT') return false;
      
      // Check lock status for edit
      if ((action === 'edit' || action === 'delete') && batchData.lock ) return false;
      
      // Permission logic
      if (hasEdit) {
        // Edit permission: can do everything
        return true;
      }
      
      if (hasCreate) {
        if (hasRead) {
          // Create + Read: can edit/delete own batches, view all
          if (action === 'view') return true;
          return batchData.user_id === this.$store.getters.getUser?.id;
        } else {
          // Create only: can edit/delete/view all
          return true;
        }
      }
      
      if (hasRead) {
        // Read only: can only view
        return action === 'view';
      }
      
      return false;
    },
    async createNewBatch() {
      try {
        this.createBatchLoading = true;
        const response = await BatchAxios.post(
          `/batch-processing/create-batch-processing`,
          {
            package_id: this.selectPackage?.package_id,
            client_id: this.selectOrganization?.id,
            tenant_id: this.getTenantId,
            entity_type_id: this.selectedEntityTypes?.id,
          }
        );
        if (response.data?.id) {
          this.$toast.success(
            this.$t("pages.batch_processing_table.batch_created_success")
          );
          this.closeModal();
          await this.fetchBatchProcessingList();
          this.$router.push({
            name: "Batch Processing Details",
            params: { id: response.data?.id, action: "edit" },
          });
        }
        this.createBatchLoading = false;
      } catch (err) {
        this.createBatchLoading = false;
        this.$toast.error(
          err?.response?.data?.detail || this.$t(`general.default_error`)
        );
      }
    },
    async fetchBatchProcessingList() {
      this.isLoading = true;
      let qParams = new URLSearchParams(this.currentPageData);
      let filterParams = {};

      const getFilterValue = (key) => {
        return this.serverParams[key].value;
      };
      if (this.serverParams) {
        Object.keys(this.serverParams).map((key) => {
          // if that key exist
          // add it to filter else we'll delete it
          // so it wont make empty strings in parameters
          filterParams[key] = this.serverParams[key]
            ? getFilterValue(key)
            : delete filterParams[key];
        });
        if (filterParams.created_at) {
          filterParams.created_at = DateTime.fromFormat(
            filterParams.created_at,
            "dd MMM yyyy"
          )
            .plus({ days: 0 })
            .toISODate();
        }
        if (filterParams.modified_at) {
          filterParams.modified_at = DateTime.fromFormat(
            filterParams.modified_at,
            "dd MMM yyyy"
          )
            .plus({ days: 0 })
            .toISODate();
        }
        if (filterParams.start_date) {
          filterParams.start_date = DateTime.fromFormat(
            filterParams.start_date,
            "dd MMM yyyy"
          )
            .plus({ days: 0 })
            .toISODate();
        }
        if (filterParams.end_date) {
          filterParams.end_date = DateTime.fromFormat(
            filterParams.end_date,
            "dd MMM yyyy"
          )
            .plus({ days: 0 })
            .toISODate();
        }
      }
      // ?${qParams}
      let url = `/batch-processing/get-batch-processing?${qParams}`;
      let { data } = await BatchAxios.get(url, {
        params: {
          ...filterParams,
          ...this.sortParams,
        },
      });

      try {
        // const formatDate = (date) => (date ? DateTime.fromISO(date).setZone('UTC').toFormat("dd MMM yyyy") : "");
        let checksData = data?.data?.map((el) => {
          if (el.created_at || el.last_updated) {
            el.created_at = this.handleDate(el.created_at);
            el.modified_at = this.handleDate(el.modified_at);
            el.start_date = this.handleDate(el.start_date);
            el.end_date = this.handleDate(el.end_date);
            return el;
          }
          if (el.parameters && el.parameters !== "null") {
            let data = JSON.parse(el.parameters);
            return { ...el, parameters: data.parameters };
          } else {
            return { ...el };
          }
        });
        this.checks = checksData;
        this.pageData = data?.page;
        this.paginationOptions.perPage = data?.page?.per_page;
      } catch (error) {
        console.log(error, "Error");
        this.isLoading = false;
      }
      // this.columns = columns;
      this.isLoading = false;
    },
    async fetchAllBatchProcessingList() {
      try {
        const { data } = await BatchAxios.get(
          "/batch-processing/get-batch-processing"
        );
        // Store all data for filtering purposes if needed
        this.allBatchData = data?.data || [];
        let checksData = data?.data?.map((el) => {
          if (el.created_at || el.last_updated) {
            el.created_at = this.handleDate(el.created_at);
            el.modified_at = this.handleDate(el.modified_at);
            el.start_date = this.handleDate(el.start_date);
            el.end_date = this.handleDate(el.end_date);
            return el;
          }
          if (el.parameters && el.parameters !== "null") {
            let data = JSON.parse(el.parameters);
            return { ...el, parameters: data.parameters };
          } else {
            return { ...el };
          }
        });
        this.checkAllData = checksData;
      } catch (error) {
        console.error("Error fetching all batch data:", error);
      }
    },

    handleDate(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      return !isNaN(parsedDate) ? FormatDateNew(parsedDate) : "";
    },
    async fetchAllOrganization() {
      try {
        // this.loaders.clients = true;
        this.organizationOptions = [];
        const { data } = await BatchAxios(
          `/batch-processing/tenant-clients-with-packages`
        );
        this.organizationOptions = data || [];
      } catch (error) {
        console.log("error :>> ", error);
      }
      // this.loaders.clients = false;
    },

    async handleSelectOrganization(value) {
      this.selectOrganization = value;
      this.selectPackage = null;
      this.selectedEntityTypes = null;
      this.selectOrganization ? await this.fetchPackagesOptions() : "";
    },
    async fetchPackagesOptions() {
      try {
        this.packageLoading = true;
        this.packageOptions = [];
        const { data } = await BatchAxios(
          `/batch-processing/client-packages/${this.selectOrganization?.id}`
        );
        this.packageOptions = data || [];
        if (this.packageOptions.length === 1) {
          this.handleSelectPackage(this.packageOptions[0]);
        }
        this.packageLoading = false;
      } catch (error) {
        console.log("error :>> ", error);
        this.$toast.error(
          this.$t(error?.response?.data?.detail || "general.default_error")
        );
        this.packageLoading = false;
      }
    },
    handleSelectPackage(value) {
      this.selectPackage = value;
      this.entityTypeOptions =
        value?.entity_types?.filter((el) => el.name !== "Case") || [];
      if (this.entityTypeOptions.length === 1) {
        this.selectedEntityTypes = this.entityTypeOptions[0];
      }
    },
    currentPageDataOpt() {
      return { ...this.currentPageData, perPage: this.currentPageData.count };
    },
    closeModal() {
      this.resetBatchModalData();
      this.$refs["batch-processing-modal"].hideModal();
      // this.organizationOptions = [];
    },

    resetBatchModalData() {
      this.selectedEntityTypes = null;
      this.selectOrganization = null;
      this.selectPackage = null;
      this.packageOptions = [];
      this.entityTypeOptions = [];
    },

    async autoSelectIfSingleOption() {
      // Auto-select organization if only one or if client mode
      if (this.getIsClient || this.organizationOptions.length === 1) {
        if (!this.getIsClient) {
          await this.handleSelectOrganization(this.organizationOptions[0]);
        }
        // Auto-select package if only one
        if (this.packageOptions.length === 1) {
          this.handleSelectPackage(this.packageOptions[0]);
          // Auto-select entity type if only one
          if (this.entityTypeOptions.length === 1) {
            this.selectedEntityTypes = this.entityTypeOptions[0];
            this.createNewBatch();
            return true;
          }
        }
      }
      // Not all selections made, return false
      return false;
    },
    async showBatchModal() {
      this.resetBatchModalData();
      // await this.fetchAllOrganization();
      this.getIsClient
        ? await this.handleSelectOrganization({ id: this.getClientId })
        : await this.fetchAllOrganization();
      const autoSelected = await this.autoSelectIfSingleOption();
      if (!autoSelected) {
        if(this.getIsClient) {
           this.packageOptions?.length ? this.$refs["batch-processing-modal"].showModal() :
           this.$toast.error(this.$t("pages.batch_processing_table.no_accessible_packages"));
        } else {
          this.$refs["batch-processing-modal"].showModal() 
        }
      }
    },

    // handleRowClick(data) {
    //   this.$router.push({
    //     name: "check admin details",
    //     params: { id: data.id },
    //   });
    // },

    handleSearchFilter: debounce(function (value) {
      this.searchValue = value;
    }, 1000),

    async onPageChange(data, resetPage = false) {
      this.currentPageData = {
        page: data.currentPage,
        count: data.currentPerPage,
      };
      if (resetPage) this.currentPageData.page = 1;
      if (!resetPage) {
        await this.$nextTick();
        const scrollTarget = document.getElementById("checkTable");
        if (scrollTarget) {
          scrollTarget.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
      await this.fetchBatchProcessingList();
    },

    getSearchOptionsTick(payload) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      const delay = 500;
      this.searchTimeout = setTimeout(() => {
        this.getSearchOptions(payload);
      }, delay);
    },

    async getSearchOptions(payload) {
      if (!payload.value) this.columnFilterOptionsAsync = null;
      else {
        this.$set(this.searchLoading, payload.column.field, true);
        try {
          const requestData = {
            ...this.serverParams,
            [payload.column.query_key || payload.column.field]: payload.value,
          };
          let qParams = new URLSearchParams(requestData);
          const { data } = await BatchAxios.get(
            `/batch-processing/get-batch-processing?${qParams}`
          );
          this.columnFilterOptionsAsync = this.getFilterOptions(
            this.columns,
            data.data
          );
        } catch (error) {
          console.log("getSearchOptions :>> ", error);
        }

        this.$set(this.searchLoading, payload.column.field, false);
      }
    },

    async onColumnFilters({ columnFilters }) {
      this.currentPageData.page = 1;
      this.paginationOptions.perPage = this.currentPageData.count;
      if (columnFilters) {
        const mappedFilters = { ...columnFilters };
        if (mappedFilters.locked_by_name) {
          mappedFilters.locked_by = mappedFilters.locked_by_name;
          delete mappedFilters.locked_by_name;
        }
        this.serverParams = mappedFilters;
      } else {
        this.serverParams = null;
      }
      await this.fetchBatchProcessingList();
    },

    async clearFilters() {
      this.serverParams = null;
      await this.fetchBatchProcessingList();
    },
    handleFilterResult(data) {
      this.searchParams.package = data;
    },
    async onSortChange(data) {
      if (data && data.length && data[0].type !== "none") {
        data = data[0];
        this.sortParams = {
          sort: data.field + ":" + data.type,
        };
        await this.fetchBatchProcessingList();
      } else {
        this.sortParams = null;
        await this.fetchBatchProcessingList();
      }
    },

    async handleDelete(rowData) {
      try {
        this.deleteLoading = true;
        const { data } = await BatchAxios.delete(
          `/batch-processing/delete_batch_id/${rowData.id}`
        );
        if (data.success) {
          this.$toast.success(this.$t("general.delete_success"));
          this.fetchBatchProcessingList();
        }
        this.deleteLoading = false;
      } catch (error) {
        console.error("error in delete", error);
        this.$toast.error(
          error?.response?.data?.detail || this.$t("general.default_error")
        );
        this.deleteLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
